module.exports = __webpack_public_path__ + "static/media/lima.ebd6d211.png";